import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة الكتلة المولية - تعلم كيفية حساب الكتلة المولية بسهولة";
const DESCRIPTION =
  "حاسبة الكتلة المولية المتقدمة: احسب كتلة أي مركب كيميائي (بالجرام/مول) بدقة! أدخل الصيغة الجزيئية (مثل H₂SO₄) لمعرفة الكتلة المولية مع شرح مفصل للخطوات الحسابية - أداة أساسية لطلاب الكيمياء والباحثين.";
const KEYWORDS = "حسب الكتلة المولية, حاسبة الكتلة المولية";
const OG_URL = "https://do-calculate.com/calculator/ar/molar-mass-calculator/";
const elements = [
  { symbol: "Ac", name: "Actinium", molarMass: 227 },
  { symbol: "Ag", name: "Silver", molarMass: 107.8682 },
  { symbol: "Al", name: "Aluminum", molarMass: 26.9815 },
  { symbol: "Am", name: "Americium", molarMass: 243 },
  { symbol: "Ar", name: "Argon", molarMass: 39.948 },
  { symbol: "As", name: "Arsenic", molarMass: 74.9216 },
  { symbol: "At", name: "Astatine", molarMass: 210 },
  { symbol: "Au", name: "Gold", molarMass: 196.9665 },
  { symbol: "Ba", name: "Barium", molarMass: 137.327 },
  { symbol: "Bk", name: "Berkelium", molarMass: 247 },
  { symbol: "Be", name: "Beryllium", molarMass: 9.0122 },
  { symbol: "Bi", name: "Bismuth", molarMass: 208.98 },
  { symbol: "Bo", name: "Boron", molarMass: 10.81 },
  { symbol: "Br", name: "Bromine", molarMass: 79.904 },
  { symbol: "Bs", name: "Bohrium", molarMass: 270 },
  { symbol: "C", name: "Carbon", molarMass: 12.011 },
  { symbol: "Ca", name: "Calcium", molarMass: 40.078 },
  { symbol: "Cd", name: "Cadmium", molarMass: 112.414 },
  { symbol: "Ce", name: "Cerium", molarMass: 140.116 },
  { symbol: "Cf", name: "Californium", molarMass: 251 },
  { symbol: "Cl", name: "Chlorine", molarMass: 35.45 },
  { symbol: "Cm", name: "Curium", molarMass: 247 },
  { symbol: "Cn", name: "Copernicium", molarMass: 285 },
  { symbol: "Co", name: "Cobalt", molarMass: 58.933 },
  { symbol: "Cr", name: "Chromium", molarMass: 51.996 },
  { symbol: "Cs", name: "Cesium", molarMass: 132.905 },
  { symbol: "Cu", name: "Copper", molarMass: 63.546 },
  { symbol: "Db", name: "Dubnium", molarMass: 268 },
  { symbol: "Ds", name: "Darmstadtium", molarMass: 281 },
  { symbol: "Dy", name: "Dysprosium", molarMass: 162.5 },
  { symbol: "Er", name: "Erbium", molarMass: 167.259 },
  { symbol: "Es", name: "Einsteinium", molarMass: 252 },
  { symbol: "Eu", name: "Europium", molarMass: 151.964 },
  { symbol: "Fm", name: "Fermium", molarMass: 257 },
  { symbol: "Fl", name: "Flerovium", molarMass: 289 },
  { symbol: "Fm", name: "Fermium", molarMass: 257 },
  { symbol: "Fr", name: "Francium", molarMass: 223 },
  { symbol: "Ga", name: "Gallium", molarMass: 69.723 },
  { symbol: "Gb", name: "Gadolinium", molarMass: 157.25 },
  { symbol: "Ge", name: "Germanium", molarMass: 72.63 },
  { symbol: "H", name: "Hydrogen", molarMass: 1.0079 },
  { symbol: "He", name: "Helium", molarMass: 4.0026 },
  { symbol: "Ho", name: "Holmium", molarMass: 164.93 },
  { symbol: "Hs", name: "Hassium", molarMass: 277 },
  { symbol: "I", name: "Iodine", molarMass: 126.904 },
  { symbol: "Ir", name: "Iridium", molarMass: 192.217 },
  { symbol: "K", name: "Potassium", molarMass: 39.098 },
  { symbol: "Kr", name: "Krypton", molarMass: 83.798 },
  { symbol: "La", name: "Lanthanum", molarMass: 138.905 },
  { symbol: "Li", name: "Lithium", molarMass: 6.94 },
  { symbol: "Lr", name: "Lawrencium", molarMass: 262 },
  { symbol: "Lu", name: "Lutetium", molarMass: 174.966 },
  { symbol: "Md", name: "Mendelevium", molarMass: 258 },
  { symbol: "Mg", name: "Magnesium", molarMass: 24.305 },
  { symbol: "Mn", name: "Manganese", molarMass: 54.938 },
  { symbol: "Mo", name: "Molybdenum", molarMass: 95.95 },
  { symbol: "Mt", name: "Meitnerium", molarMass: 278 },
  { symbol: "N", name: "Nitrogen", molarMass: 14.007 },
  { symbol: "Na", name: "Sodium", molarMass: 22.99 },
  { symbol: "Nb", name: "Niobium", molarMass: 92.906 },
  { symbol: "Nd", name: "Neodymium", molarMass: 144.242 },
  { symbol: "Ne", name: "Neon", molarMass: 20.18 },
  { symbol: "Np", name: "Neptunium", molarMass: 237 },
  { symbol: "Os", name: "Osmium", molarMass: 190.23 },
  { symbol: "O", name: "Oxygen", molarMass: 15.999 },
  { symbol: "Pd", name: "Palladium", molarMass: 106.42 },
  { symbol: "P", name: "Phosphorus", molarMass: 30.974 },
  { symbol: "Pt", name: "Platinum", molarMass: 195.084 },
  { symbol: "Pu", name: "Plutonium", molarMass: 244 },
  { symbol: "Pa", name: "Protactinium", molarMass: 231.035 },
  { symbol: "Rb", name: "Rubidium", molarMass: 85.4678 },
  { symbol: "Re", name: "Rhenium", molarMass: 186.207 },
  { symbol: "Rh", name: "Rhodium", molarMass: 102.905 },
  { symbol: "Ru", name: "Ruthenium", molarMass: 101.07 },
  { symbol: "S", name: "Sulfur", molarMass: 32.06 },
  { symbol: "Sb", name: "Antimony", molarMass: 121.76 },
  { symbol: "Sc", name: "Scandium", molarMass: 44.955 },
  { symbol: "Se", name: "Selenium", molarMass: 78.971 },
  { symbol: "Si", name: "Silicon", molarMass: 28.085 },
  { symbol: "Sm", name: "Samarium", molarMass: 150.36 },
  { symbol: "Sn", name: "Tin", molarMass: 118.71 },
  { symbol: "Sr", name: "Strontium", molarMass: 87.62 },
  { symbol: "Ta", name: "Tantalum", molarMass: 180.947 },
  { symbol: "Tb", name: "Terbium", molarMass: 158.925 },
  { symbol: "Tc", name: "Technetium", molarMass: 98 },
  { symbol: "Te", name: "Tellurium", molarMass: 127.6 },
  { symbol: "Th", name: "Thorium", molarMass: 232.038 },
  { symbol: "Ti", name: "Titanium", molarMass: 47.867 },
  { symbol: "Tl", name: "Thallium", molarMass: 204.38 },
  { symbol: "Tm", name: "Thulium", molarMass: 168.934 },
  { symbol: "U", name: "Uranium", molarMass: 238.028 },
  { symbol: "V", name: "Vanadium", molarMass: 50.941 },
  { symbol: "W", name: "Tungsten", molarMass: 183.84 },
  { symbol: "Xe", name: "Xenon", molarMass: 131.293 },
  { symbol: "Y", name: "Yttrium", molarMass: 88.906 },
  { symbol: "Yb", name: "Ytterbium", molarMass: 173.04 },
  { symbol: "Zn", name: "Zinc", molarMass: 65.38 },
  { symbol: "Zr", name: "Zirconium", molarMass: 91.224 },
];
function Calculator() {
  const [compound, setCompound] = useState([{ element: "", atoms: 1 }]);
  const [molarMass, setMolarMass] = useState("");
  const [explanation, setExplanation] = useState("");
  const [error, setError] = useState("");
  const handleAddElement = () => {
    setCompound([...compound, { element: "", atoms: 1 }]);
  };
  const handleElementChange = (index, value) => {
    const newCompound = [...compound];
    newCompound[index].element = value;
    setCompound(newCompound);
  };
  const handleAtomChange = (index, value) => {
    const newCompound = [...compound];
    newCompound[index].atoms = value;
    setCompound(newCompound);
  };
  const handleCalculate = () => {
    let totalMolarMass = 0;
    let explanationSteps = "";
    for (const { element, atoms } of compound) {
      if (!element) {
        setError("الرجاء إدخال جميع العناصر وعدد الذرات بشكل صحيح");
        setMolarMass("");
        setExplanation("");
        return;
      }
      const elementData = elements.find((e) => e.symbol === element);
      if (!elementData) {
        setError("عنصر غير صالح. الرجاء اختيار عنصر صحيح.");
        setMolarMass("");
        setExplanation("");
        return;
      }
      const elementMolarMass = elementData.molarMass * atoms;
      totalMolarMass += elementMolarMass;
      explanationSteps += `${atoms} × ${elementData.molarMass
        } (الكتلة المولية لـ${elementData.name}) = ${elementMolarMass.toFixed(
          2
        )} جرام/مول\n`;
    }
    setMolarMass(totalMolarMass.toFixed(2));
    setExplanation(explanationSteps);
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  الكتلة المولية هي كتلة مول واحد من العنصر أو المركب الكيميائي.
                  لحساب الكتلة المولية لمركب معين، يجب جمع الكتل المولية لكل
                  الذرات الموجودة في المركب. الكتلة المولية للعنصر يمكن العثور
                  عليها في الجدول الدوري، وهي بوحدة جرام/مول. على سبيل المثال،
                  لحساب الكتلة المولية للماء (H2O):
                </p>
                <ul>
                  <li>كتلة الهيدروجين المولية = 1.008 جرام/مول</li>
                  <li>كتلة الأكسجين المولية = 16.00 جرام/مول</li>
                  <li>
                    الكتلة المولية للماء = (2 × 1.008) + 16.00 = 18.016 جرام/مول
                  </li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  {compound.map((item, index) => (
                    <div
                      key={index}
                      className="form-group d-flex align-items-center"
                    >
                      <b>
                        <label className="form-label ms-2">
                          العنصر {index + 1}
                        </label>
                      </b>
                      <select
                        value={item.element}
                        onChange={(e) =>
                          handleElementChange(index, e.target.value)
                        }
                        className="form-control"
                        style={{ width: "150px", marginRight: "10px" }}
                      >
                        <option value="">اختر العنصر</option>
                        {elements.map((el) => (
                          <option key={el.symbol} value={el.symbol}>
                            {el.name} ({el.symbol})
                          </option>
                        ))}
                      </select>
                      <input
                        type="number"
                        min="1"
                        placeholder="عدد الذرات"
                        value={item.atoms}
                        onChange={(e) =>
                          handleAtomChange(index, parseInt(e.target.value))
                        }
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  ))}
                  <br />
                  <button
                    className="btn btn-success"
                    onClick={handleAddElement}
                  >
                    إضافة عنصر آخر
                  </button>
                  <br/>                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={handleCalculate}
                  >
                    احسب                  </button>
                </div>
                <br />
                <div>
                  { error !== "" ? (
                    <p className="p-3 mb-2 bg-warning text-white">
                      خطأ: {error}
                    </p>
                  ) : (
                    <>
                      { molarMass !== "" && (
                        <>
                          <p className="p-3 mb-2 bg-success text-white">
                            الكتلة المولية (جرام/مول): {molarMass}
                          </p>
                          {explanation !== "" && (
                            <p className="p-3 mb-2 bg-info text-black">
                              خطوات الحساب: <br />
                              {explanation.split("\n").map((line, index) => (
                                <React.Fragment key={index}>
                                  {line}
                                  <br />
                                </React.Fragment>
                              ))}
                            </p>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      {" "}
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>ما هي الكتلة المولية؟</h3>
              </div>
              <div className="info-section-body">
                <p>
                  الكتلة المولية هي كتلة مول واحد من مادة ما. المول هو وحدة قياس
                  كمية المادة، ويساوي 6.022 × 10^23 جسيمًا (ذرات، جزيئات،
                  أيونات).
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>لماذا الكتلة المولية مهمة؟</h3>
              </div>
              <div className="info-section-body">
                <p>
                  الكتلة المولية تستخدم في العديد من الحسابات الكيميائية، مثل:
                </p>
                <ul>
                  <li>تحويل بين الكتلة وعدد المولات</li>
                  <li>تحديد الصيغة الكيميائية للمركبات</li>
                  <li>حساب التركيزات</li>
                  <li>حساب النسب الوزنية في التفاعلات الكيميائية</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>وحدات الكتلة المولية</h3>
              </div>
              <div className="info-section-body">
                <p>وحدة الكتلة المولية هي جرام/مول (جم/مول).</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  الكتلة المولية والصيغة التجريبية
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  يمكن استخدام الكتلة المولية لتحديد الصيغة التجريبية لمركب.
                  الصيغة التجريبية هي أبسط نسبة صحيحة بين عدد ذرات العناصر في
                  المركب.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  الكتلة المولية في المعادلات الكيميائية
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  تستخدم الكتلة المولية في تحويل بين كتلة المواد وعدد المولات في
                  المعادلات الكيميائية. وهذا يسمح بحساب الكميات الناتجة من
                  التفاعلات الكيميائية.
                </p>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default Calculator;
